'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var _extends = require('@babel/runtime/helpers/extends');
var React = require('react');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

function _interopNamespace(e) {
  if (e && e.__esModule) return e;
  var n = Object.create(null);
  if (e) {
    Object.keys(e).forEach(function (k) {
      if (k !== 'default') {
        var d = Object.getOwnPropertyDescriptor(e, k);
        Object.defineProperty(n, k, d.get ? d : {
          enumerable: true,
          get: function () { return e[k]; }
        });
      }
    });
  }
  n["default"] = e;
  return Object.freeze(n);
}

var _extends__default = /*#__PURE__*/_interopDefaultLegacy(_extends);
var React__namespace = /*#__PURE__*/_interopNamespace(React);

const Exchange = props => /*#__PURE__*/React__namespace.createElement("svg", _extends__default["default"]({
  width: "32",
  height: "32",
  viewBox: "0 0 32 32",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  "data-testid": "ExchangeIcon"
}, props), /*#__PURE__*/React__namespace.createElement("g", {
  filter: "url(#filter0_d_4944_41906)"
}, /*#__PURE__*/React__namespace.createElement("circle", {
  cx: "16",
  cy: "16",
  r: "9",
  fill: "white"
}), /*#__PURE__*/React__namespace.createElement("g", {
  clipPath: "url(#clip0_4944_41906)"
}, /*#__PURE__*/React__namespace.createElement("path", {
  d: "M10 18.1368C11.432 14.8636 14.7051 12.4091 19.4103 16.0914",
  stroke: "black",
  strokeWidth: "1.69181"
}), /*#__PURE__*/React__namespace.createElement("path", {
  d: "M22.1027 18.5784L16.8392 18.2384L21.7627 13.3149L22.1027 18.5784Z",
  fill: "black"
}))), /*#__PURE__*/React__namespace.createElement("defs", null, /*#__PURE__*/React__namespace.createElement("filter", {
  id: "filter0_d_4944_41906",
  x: "0.0769229",
  y: "0.0769229",
  width: "31.8462",
  height: "31.8462",
  filterUnits: "userSpaceOnUse",
  colorInterpolationFilters: "sRGB"
}, /*#__PURE__*/React__namespace.createElement("feFlood", {
  floodOpacity: "0",
  result: "BackgroundImageFix"
}), /*#__PURE__*/React__namespace.createElement("feColorMatrix", {
  in: "SourceAlpha",
  type: "matrix",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
  result: "hardAlpha"
}), /*#__PURE__*/React__namespace.createElement("feOffset", null), /*#__PURE__*/React__namespace.createElement("feGaussianBlur", {
  stdDeviation: "3.46154"
}), /*#__PURE__*/React__namespace.createElement("feComposite", {
  in2: "hardAlpha",
  operator: "out"
}), /*#__PURE__*/React__namespace.createElement("feColorMatrix", {
  type: "matrix",
  values: "0 0 0 0 0.833333 0 0 0 0 0.833333 0 0 0 0 0.833333 0 0 0 1 0"
}), /*#__PURE__*/React__namespace.createElement("feBlend", {
  mode: "normal",
  in2: "BackgroundImageFix",
  result: "effect1_dropShadow_4944_41906"
}), /*#__PURE__*/React__namespace.createElement("feBlend", {
  mode: "normal",
  in: "SourceGraphic",
  in2: "effect1_dropShadow_4944_41906",
  result: "shape"
})), /*#__PURE__*/React__namespace.createElement("clipPath", {
  id: "clip0_4944_41906"
}, /*#__PURE__*/React__namespace.createElement("rect", {
  width: "14",
  height: "6",
  fill: "white",
  transform: "translate(9 13)"
}))));

exports["default"] = Exchange;
